import { BaseConstants } from '@app/core.module';

export enum Mode {
    New = 1,
    Edit
}

export class Constants extends BaseConstants {
    public static routerPaths = {
        login: 'login',
        forgotPassword: 'forgot-password',
        app: 'app',
        layoutModule: 'layout/layout.module#LayoutModule',
        configuration: 'configuration',
        configurationModule: 'configuration.module/configuration.module#ConfigurationModule',
        noMatch: '**',
        pageNotFound: 'page-not-found'
    };

    public static apiEndPoints = {
        getEventChecklist: 'api/eventchecklist',
        downloadDocument: 'api/attachment/download',
        deleteDocument: 'api/attachment/delete',
        upload: 'api/v1/moduleName/upload',
        // registrantUpload: 'api/v1/registration/upload',
        // importUpload: 'api/v1/DI/upload',
        // eventUpload: 'api/v1/eventData/upload'

    };
    public static HTMLConstants = {
        InvalidFileSize: 'Max file size can be 10 MB',
        InvalidFileExtension: 'Unsupported file type',
        successMessage: 'Information has been updated successfully',
        errorMessage: 'An error occurred while processing your request. Please contact administrator'
    };

}
export enum TemplatesName {
    EventDataTemplate,
    RegistrationTemplate,
    ImportCourceTemplate
};

export enum ModuleNames {
    registration = 'registration',
    course = 'course',
    eventData = 'eventData',
}
